import {
  Box,
  Button,
  Container,
  Heading,
  Input,
  Stack,
} from "@chakra-ui/react";
import { useState } from "react";
import CustomCategoriesTags from "../components/CustomCategoriesTags";
import { useCustomCategories } from "../context/CustomCatgoriesContext";

const AddCustomCategoryPage = () => {
  const [newCategory, setNewCategory] = useState("");
  const { addCategory } = useCustomCategories();

  const handleAdd = () => {
    if (newCategory.trim() === "") return;
    addCategory(newCategory.trim());
    setNewCategory("");
  };

  return (
    <Container maxW="lg" py={10} pb={{ base: 24, md: 10 }}>
      <Heading textAlign="center">Kategorien hinzufügen</Heading>
      <Stack spaceY={4} mt={14}>
        <Input
          placeholder="Neue Kategorie z. B. Fitness"
          value={newCategory}
          borderColor="gray"
          onChange={(e) => setNewCategory(e.target.value)}
        />
        <Button onClick={handleAdd}>Kategorie hinzufügen</Button>
        <Box mt={6}>
          <CustomCategoriesTags />
        </Box>
      </Stack>
    </Container>
  );
};

export default AddCustomCategoryPage;
